@use '@design/design-tokens/typography/typography' as *;

.titleWrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.description {
  @include typography-v2-body-base;
}

.chipsWrapper {
  display: flex;
  gap: 8px;
}

.warningText {
  @include typography-v2-body-sm;

  color: var(--text-critical);
}

.inputWrapper {
  margin-top: 32px;
}

.chatInputComposerWrapper {
  width: 100%;
  max-width: 634px;

  form {
    width: 100%;
  }
}
